import { defineMessages } from 'react-intl';

export const messagesFlixmedia = defineMessages({
  flixmediaCardTitle: {
    id: 'flixmedia.card.title',
    defaultMessage: 'Weitere Herstellerinformationen von Dyson',
  },
  flixmediaModalTitle: {
    id: 'flixmedia.modal.title',
    defaultMessage: 'Weitere Herstellerinformationen von Dyson',
  },
});
